import { EntityRepository, Repository } from "typeorm";
import { EmployeeSkillMatrix } from "../employee-skill-matrix.entity";
import { EmployeeDetails } from "../employee-details.entity";
import { EmpSkillMatrixReq } from "./employee-skill-matrix-id.req";
import { UnitCodes } from "../../unit-codes/unit-codes.entity";
import { EmpSkillMatrix } from "./employees-skillMatrix";


@EntityRepository(EmployeeSkillMatrix)
export class EmployeeSkillMatrixRepo extends Repository<EmployeeSkillMatrix> {
    constructor(){
        super()
    }
    async getEmployeesSkillMatrix(req?:EmpSkillMatrix): Promise<any> {
        const query = this.createQueryBuilder("esm")
            .select([
                'esm.machine_wise AS machineSkills',
                'esm.of_skill_aquired AS OfSkillAquired',
                'em.employee_name AS EmployeesName,em.unit_id AS UnitId',
                'ui.unit_name AS Plant',
            ])
            .leftJoin(EmployeeDetails, 'em', 'em.employee_id = esm.employee_id')
            .leftJoin(UnitCodes,'ui','ui.unit_code_id = em.unit_id')
           if (req?.employeeId) {
            query.where('em.employee_id = :employeesId', { employeesId: req.employeeId });
        }
        if (req?.plant) {
            query.andWhere('em.unit_id = :unitId', { unitId: req.plant }); 
        }
       const rawResults = await query.getRawMany();
      const groupedData = rawResults.reduce((acc, row) => {
            const { EmployeesName, OfSkillAquired: skillPercent, machineSkills } = row;
           let employee = acc.find(emp => emp.name === EmployeesName);
           if (!employee) {
                employee = {
                    name: EmployeesName,
                    skills: [], 
                    totalSkillPercent: 0, 
                };
                acc.push(employee);
            }
         employee.skills.push(skillPercent);
    
           employee.totalSkillPercent += parseFloat(skillPercent) * (14 / 100);
    
            return acc;
        }, []);
    
       
        return groupedData;
    }
    
    
    
    
}
